var Handlebars = require("/Users/Shanfan/enhancer/widget-configurator/enhancer-custom-window/node_modules/handlebars/runtime.js");
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<div class=\"supported-events ui-widget-content\">\n    <div class=\"supported-events-title ui-widget-header\">\n        "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.supeventstitle : stack1), depth0))
    + "\n    </div>\n    <ul class=\"supported-event-list\"></ul>\n    <input id=\"supported-event\" placeholder=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.eventName : stack1), depth0))
    + "\" type=\"text\">\n    <input id=\"supported-event-des\" placeholder=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.description : stack1), depth0))
    + "\" type=\"text\">\n    <button id=\"add-event-var\" class=\"add\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.locale : depth0)) != null ? stack1.add : stack1), depth0))
    + "</button>\n</div>";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./src/managers/event/index.html
 ** module id = 37
 ** module chunks = 0
 **/